if (!window.VantaCartGroups) {
  window.VantaCartGroups = true;
  const enhance = () => {
    const tables = new Map();
    document.querySelectorAll('.cart-item[data-vanta-offer-group]').forEach((row) => {
      const group = row.dataset.vantaOfferGroup;
      if (!group) return;
      const groups = tables.get(row.parentElement) || new Map();
      const rows = groups.get(group) || [];
      rows.push(row);
      groups.set(group, rows);
      tables.set(row.parentElement, groups);
    });

    tables.forEach((groups) => {
      groups.forEach((rows, group) => {
        const firstRow = rows[0];
        const headers = Array.from(firstRow.parentElement.querySelectorAll('.vanta-offer-group-header'))
          .filter((header) => header.dataset.vantaGroupHeader === group);
        const groupHeader = headers.shift();
        headers.forEach((duplicate) => duplicate.remove());
        const columnCount = firstRow.children.length;
        if (groupHeader?.nextElementSibling === firstRow) {
          const cell = groupHeader.querySelector('td');
          if (cell) cell.colSpan = columnCount;
          return;
        }

        const header = groupHeader || document.createElement('tr');
        header.className = 'vanta-offer-group-header';
        header.dataset.vantaGroupHeader = group;
        const quantity = firstRow.dataset.vantaOfferQuantity || '';
        const pairLabel = Number(quantity) === 1 ? 'par' : 'pares';
        header.innerHTML = `<td colspan="${columnCount}"><div class="vanta-offer-group-header__content"><span class="vanta-offer-group-header__title">Oferta por cantidad <small>${quantity ? `${quantity} ${pairLabel}` : ''}</small></span><button class="vanta-offer-group-remove" type="button" aria-label="Eliminar esta oferta">Eliminar oferta</button></div></td>`;
        header.querySelector('button').addEventListener('click', async () => {
          const button = header.querySelector('button');
          if (button.disabled) return;

          button.disabled = true;
          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');

          try {
            const cart = await fetch('/cart.js').then((response) => response.json());
            const updates = {};
            cart.items.forEach((item) => {
              if (item.properties?._vanta_offer_group === group) updates[item.key] = 0;
            });

            const drawer = document.querySelector('cart-drawer');
            const isDrawerOpen = drawer?.classList.contains('active');
            const cartItems = document.querySelector('cart-items');
            const sections = isDrawerOpen
              ? ['cart-drawer', 'cart-icon-bubble']
              : cartItems?.getSectionsToRender?.().map((section) => section.section) || ['cart-icon-bubble'];

            const result = await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                updates,
                sections,
                sections_url: window.location.pathname,
              }),
            }).then(async (response) => {
              const data = await response.json();
              if (!response.ok) throw new Error(data.description || 'No se pudo actualizar el carrito.');
              return data;
            });

            if (isDrawerOpen && drawer?.renderContents && result.sections) {
              drawer.renderContents(result);
            } else if (cartItems?.getSectionsToRender && result.sections) {
              cartItems.classList.toggle('is-empty', result.item_count === 0);
              document.getElementById('main-cart-footer')?.classList.toggle('is-empty', result.item_count === 0);

              cartItems.getSectionsToRender().forEach((section) => {
                const sectionElement = document.getElementById(section.id);
                if (!sectionElement || !result.sections[section.section]) return;
                const target = sectionElement.querySelector(section.selector) || sectionElement;
                target.innerHTML = cartItems.getSectionInnerHTML(result.sections[section.section], section.selector);
              });
            } else {
              document.querySelectorAll(`[data-vanta-offer-group="${group}"]`).forEach((row) => row.remove());
              header.remove();
            }
          } catch (error) {
            button.disabled = false;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            console.error(error);
          }
        });
        firstRow.before(header);
      });
    });
  };
  document.addEventListener('DOMContentLoaded', enhance);
  new MutationObserver(enhance).observe(document.documentElement, { childList: true, subtree: true });
}
